import React, { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AppBar from '../../components/AppBar';
import { MdEmail, MdLock, MdVisibility, MdVisibilityOff } from 'react-icons/md';

import './Login.css';
import Footer from '../../components/Footer';
import { AuthContext } from '../../context/AuthContext';
import { APP_CONFIG } from "../../config/appConfig";
import { Link } from 'react-router-dom';



const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login, user, loading: authLoading } = useContext(AuthContext);


  const navigate = useNavigate();

  const BASE_URL = APP_CONFIG.API_BASE_URL;

  useEffect(() => {
    if (!authLoading && user) {
      navigate('/wallets', { replace: true });
    }
  }, [authLoading, user, navigate]);

  if (authLoading || user) {
    return null;
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    const normalizedEmail = email.toLowerCase().trim();

    try {
      const response = await fetch(`${BASE_URL}/login/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include', // httpOnly cookie
        body: JSON.stringify({ email: normalizedEmail, password }),
      });

      const data = await response.json();

      if (response.ok) {
        // Only store UI flag
        localStorage.setItem('isAuthenticated', 'true');

        // Update AuthContext with user info
        login(data.user, null);

        window.location.href = '/dashboard';
      } else {
        setError(data.error || 'Invalid email or password.');
      }
    } catch (err) {
      console.error('Login error:', err);
      setError('Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };


  return (
    <div>
      <div className="login-page">
        <AppBar />
        <div className="login-page-wrapper">
          <div className="login-page-container">
            <h2 className="login-page-heading">Log in</h2>
            <hr className="login-page-divider" />
            
            {error && <p className="login-page-error">{error}</p>}
            
            <form onSubmit={handleSubmit} className="login-page-form">
              <label className="login-page-label">Email</label>
              <div className="login-page-input-with-icon">
                <MdEmail className="login-page-input-icon" />
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Email"
                  className="login-page-input"
                  required
                />
              </div>

              <label className="login-page-label">Password</label>
              <div className="login-page-input-with-icon">
                <MdLock className="login-page-input-icon" />
                <input
                  type={showPassword ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Password"
                  className="login-page-input login-page-input-padded-right"
                  required
                />
                <button
                  type="button"
                  className="login-page-eye-icon"
                  onClick={() => setShowPassword((v) => !v)}
                  tabIndex={-1}
                >
                  {showPassword ? <MdVisibilityOff /> : <MdVisibility />}
                </button>
              </div>


              <p className="login-page-forgot-link">
                <Link to="/forgot-password">Forgotten password?</Link>
              </p>

              <button type="submit" className="login-page-button" disabled={loading}>
                Log In
              </button>
            </form>
            
            <p className="login-page-signup-link">
             Don't have an account? <Link to="/signup">Sign up here</Link>
            </p>
          </div>
        </div>
        
        <p className="login-page-terms">
          By logging in, you agree to our <a href="/terms">Terms of Service</a> and <a href="/privacy">Privacy Policy</a>
        </p>
        
        {loading && (
          <div className="login-page-loading-overlay">
            <div className="login-page-spinner"></div>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default Login;